export default __webpack_public_path__ + "static/media/detail_mobile_10_4.5dcf9e07.jpg";